"use client";

import Layout from "components/layouts/Layout";
import { usePathname, useRouter } from "next/navigation";
import { useBookingStore } from "stores";
import dayjs from "utils/dayjs";
import MessageIcon from "components/chat/MessageIcon";
import NotificationProvider from "components/providers/NotificationProvider";

export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const router = useRouter();
  const { setSelectedDate } = useBookingStore();

  const handleDateChange = (date: any) => {
    setSelectedDate(date || dayjs().startOf("day"));
  };

  const handleMessageClick = () => {
    router.push("/chat");
  };

  // Page-specific header configurations
  let headerType: "default" | "detail" | "account" = "default";
  let headerProps: any = {};

  switch (pathname) {
    case "/":
      headerType = "detail";
      headerProps = { onChangeDate: handleDateChange };
      break;
    case "/manage":
      headerProps = { title: "Quản lý", layout: "primary" };
      break;
    case "/promotion":
      headerProps = { title: "Ưu đãi", layout: "primary", borderRadius: true };
      break;
    case "/notification":
      headerProps = {
        title: "Thông báo",
        layout: "primary",
        rightContent: (
          <button
            onClick={handleMessageClick}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-full transition-colors"
          >
            <MessageIcon size={24} color="#fff" />
          </button>
        )
      };
      break;
    case "/account":
      headerType = "account";
      headerProps = { layout: "primary" };
      break;
  }

  return (
    <NotificationProvider>
      <Layout
        header={headerType}
        headerProps={headerProps}
        bottomTab={true}
        requireAuth={true}
      >
        {children}
      </Layout>
    </NotificationProvider>
  );
}